var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 557,
    height: 557,
    viewBox: "0 0 557 557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6984",
    "data-name": "Group 6984",
    transform: "translate(-24 -5070)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_396",
    "data-name": "Ellipse 396",
    transform: "translate(44 5090)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 268.5,
    r: 268.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 268.5,
    r: 268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_397",
    "data-name": "Ellipse 397",
    transform: "translate(24 5070)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 268.5,
    r: 268.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 268.5,
    r: 268,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLine);
export default __webpack_public_path__ + "static/media/footer-line.90bebfa588518f587e477c5daeab65b1.svg";
export { ForwardRef as ReactComponent };